import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Grid, ImageGallery, AddToCart } from ".."
import ProductDescription from "./productDescription"

const useStyles = makeStyles(theme => {
  return {
    root: {
      overflow: "visible",
      padding: theme.spacing(10, 0),
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(4, 0),
      },
      background:
        "linear-gradient(180deg, " +
        theme.palette.gray.support +
        " 0%, " +
        theme.palette.white.main +
        " 100%)",
    },
    gallery: {
      height: 546,
      [theme.breakpoints.down("md")]: {
        height: "50vh",
      },
    },
    description: {
      display: "flex",
      flexDirection: "column",
      minHeight: 546,
      [theme.breakpoints.down("md")]: {
        height: "auto",
      },
    },
  }
})

export default props => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Grid container centered>
        <Grid item xs={8} lg={7}>
          <ImageGallery className={classes.gallery} images={props.images}/>
        </Grid>
        <Grid item xs={8} lg={5}>
          <div className={classes.description}>
            <ProductDescription
              color={props.color}
              name={props.name}
              price={props.price}
              description={props.description}
              cbdQuantity={props.cbdQuantity}
              keywords={props.keywords}
              volume={props.volume}
              outOfStock={props.outOfStock}
              isOutOfStock={props.isOutOfStock}
              langKey={props.langKey}
            />
            {props.langKey === "es" &&
            <AddToCart
              isDisabled={props.isOutOfStock || props.isComingSoon}
              color={props.color}
              itemId={props.itemId}
              langKey={props.langKey}
            />
            }
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
